export default function getColorByOrderStatus(status) {
    if (status === "1" || status === "2" || status === "3" || status === "6")
        return "blueColor"
    else if (status === "4" || status === "7" || status === "9" || status === "10")
        return "greenColor"
    else if (status === "5" || status === "8" || status === "11")
        return "redColor"
}